import React from "react";
import "../../styles/components/floating-button.css";

const FloatingButton = ({
  children,
  onClick,
  className = "",
  variant = "primary", // primary, secondary, success, danger, warning, info
  size = "medium", // small, medium, large
  icon,
  disabled = false,
  loading = false,
  animationDelay = "0s",
  type,
  title,
  ...rest
}) => {
  // Forward accessibility / testing attributes (aria-label, aria-*, data-*,
  // id) — icon-only buttons need an accessible name (BUG-44).
  const passThrough = Object.fromEntries(
    Object.entries(rest).filter(([key]) => key === "id" || key.startsWith("aria-") || key.startsWith("data-"))
  );

  const buttonClasses = [
    "floating-btn",
    `floating-btn-${variant}`,
    `floating-btn-${size}`,
    disabled ? "floating-btn-disabled" : "",
    loading ? "floating-btn-loading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const buttonStyle = {
    animationDelay,
  };

  return (
    <button
      {...passThrough}
      {...(type ? { type } : {})}
      {...(title ? { title } : {})}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      style={buttonStyle}
    >
      {loading && <span className="floating-btn-spinner"></span>}
      {icon && <span className="floating-btn-icon" aria-hidden="true">{icon}</span>}
      <span className="floating-btn-text">{children}</span>
    </button>
  );
};

export default FloatingButton;
